<template lang="pug">
.address
  .form-group.row
    .col-sm-12
      h2 {{ name }}
        button.btn.btn-sm.btn-link.copy(v-if="copyAddress" v-on:click.prevent="copy" style="display:inline; text-decoration:none;") {{copyText}}
  .form-group.row
    label.col-sm-2.col-form-label(for="i-name1") Firma
    .col-sm-8
      input.form-control.form-control-sm(v-model="address.name1" :class="[{ 'is-invalid': vm(addressType+'.name1') }, 'form-control']")
      .error.invalid-feedback(v-if="vm(addressType+'.name1')") {{ vm(addressType+'.name1') }}
  .form-group.row
    label.col-sm-2.col-form-label(for="i-name2") Name
    .col-sm-8
      input.form-control.form-control-sm(v-model="address.name2" :class="[{ 'is-invalid': vm(addressType+'.name2') }, 'form-control']")
      .error.invalid-feedback(v-if="vm(addressType+'.name2')") {{ vm(addressType+'.name2') }}
  .form-group.row
    label.col-sm-2.col-form-label(for="i-street") Straße
    .col-sm-8
      input.form-control.form-control-sm(v-model="address.street" :class="[{ 'is-invalid': vm(addressType+'.street') }, 'form-control']")
      .error.invalid-feedback(v-if="vm(addressType+'.street')") {{ vm(addressType+'.street') }}
  .form-group.row
    label.col-sm-2.col-form-label(for="i-zip") PLZ
    .col-sm-8
      input.form-control.form-control-sm(v-model="address.zip" :class="[{ 'is-invalid': vm(addressType+'.zip') }, 'form-control']")
      .error.invalid-feedback(v-if="vm(addressType+'.zip')") {{ vm(addressType+'.zip') }}
  .form-group.row
    label.col-sm-2.col-form-label(for="i-city") Stadt
    .col-sm-8
      input.form-control.form-control-sm(v-model="address.city" :class="[{ 'is-invalid': vm(addressType+'.city') }, 'form-control']")
      .error.invalid-feedback(v-if="vm(addressType+'.city')") {{ vm(addressType+'.city') }}
  .form-group.row
    label.col-sm-2.col-form-label(for="i-country") Land
    .col-sm-8
      select.form-control.form-control-sm(v-if="austriaEnabled" v-model="address.country" :class="[{ 'is-invalid': vm(addressType+'.country') }, 'form-control']")
        option(value="DE") Deutschland
        option(value="AT") Österreich
      input.form-control.form-control-sm(v-else value="Deutschland" readonly :class="[{ 'is-invalid': vm(addressType+'.country') }, 'form-control']")
      .error.invalid-feedback(v-if="vm(addressType+'.country')") {{ vm(addressType+'.country') }}
</template>

<script>
export default {
  name: 'AddressForm',
  props: {
    name: {
      type: String,
      required: false,
      default: 'Adresse'
    },
    copyText: {
      type: String,
      required: false,
      default: 'Adresse kopieren'
    },
    address: {
      type: Object,
      required: false,
      default: () => {}
    },
    copyAddress: {
      type: Object,
      required: false,
      default: () => null
    },
    validationMessages: {
      type: Object,
      required: false,
      default: () => {}
    },
    addressType: {
      type: String,
      required: false,
      default: 'invoice' // or delivery
    },
    displayValidation: {
      type: Boolean,
      required: false,
      default: false
    },
    austriaEnabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    vm (slug) {
      if (!this.displayValidation) {
        return false
      }
      return this.validationMessages[slug]
    },
    copy () {
      this.address.name1 = this.copyAddress.name1
      this.address.name2 = this.copyAddress.name2
      this.address.street = this.copyAddress.street
      this.address.zip = this.copyAddress.zip
      this.address.city = this.copyAddress.city
    }
  }
}
</script>
